import React, { useState, useEffect, useRef } from "react";
import Header from "../../compnents/Header";
import {
  Container,
  Row,
  Col,
  Dropdown,
  Button,
  ButtonGroup,
  Modal,
  Alert,
  Pagination,
} from "react-bootstrap";
import "./artwork.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileAlt,
  faFileAudio,
  faFilePdf,
  faImage,
  faLink,
  faPaperclip,
  faUpload,
  faVideo,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadArtworkRequest,
  uploadArtworkSuccess,
} from "../../redux/reducer/ArtworkReducer";
import { fetchArtworkRequest } from "../../redux/reducer/ArtworkViewReducer";
import {
  shareArtworkRequest,
  clearShareUrl,
} from "../../redux/reducer/ArtworkShareReducer";
import { faViadeo } from "@fortawesome/free-brands-svg-icons";
import check from "../../assets/images/check.gif";
import { useLocation } from "react-router-dom";

function FilePreview({ art, onShare }) {
  // console.log("check art:::", art?.share);
  const dispatch = useDispatch();
  const { shareResponse, loading, error } = useSelector(
    (state) => state.ArtworkShareReducer
  );
  // console.log("res:::", shareResponse);
  const [duration, setDuration] = useState("For 1 day");
  const [localError, setLocalError] = useState(null);
  const [copy, setCopy] = useState("");
  const options = [
    "For 1 day",
    "For 7 days",
    "For 15 days",
    "For 30 days",
    "For 60 days",
    "For 90 days",
  ];

  // Map UI value to days
  const getDurationVal = (label) => {
    switch (label) {
      case "For 1 day":
        return 1;
      case "For 7 days":
        return 7;
      case "For 15 days":
        return 15;
      case "For 30 days":
        return 30;
      case "For 60 days":
        return 60;
      case "For 90 days":
        return 90;
      default:
        return 3650;
    }
  };
function copyText() {
  setCopy("Link Copied!");

  // remove the message after 500ms
  setTimeout(() => {
    setCopy("");
  }, 500);
}



  console.log(copy)
  // Handle new share request
  const handleShare = () => {
    const durationVal = 90;
    dispatch(
      shareArtworkRequest({
        s3_key: art.s3_key,
        duration: durationVal,
      })
    );
  };

  // ✅ Handle success
  useEffect(() => {
    if (shareResponse && shareResponse.s3_key === art.s3_key) {
      onShare(shareResponse);

      // Call the view API again
      dispatch(fetchArtworkRequest());

      // Console the success response
      // console.log("View API called after share success:", shareResponse);

      dispatch(clearShareUrl());
    }
  }, [shareResponse, art.s3_key, onShare, dispatch]);

  // ✅ Handle error
  useEffect(() => {
    if (error) {
      setLocalError(error.message || "Something went wrong");
      dispatch(clearShareUrl());
    }
  }, [error, dispatch]);

  // Detect file icon
  const fileName = art.file_name || "unknown.file";
  const ext = fileName.split(".").pop().toLowerCase();

  let icon = faFileAlt;
  if (/(jpg|jpeg|png|gif|webp)$/i.test(ext)) icon = faImage;
  else if (/(mp4|mov|avi|webm)$/i.test(ext)) icon = faVideo;
  else if (/(mp3|wav)$/i.test(ext)) icon = faFileAudio;
  else if (ext === "pdf") icon = faFilePdf;

  // ✅ Filter only valid links
  const validShares = Array.isArray(art.shares || [art.share])
    ? (art.shares || []).filter((s) => s?.preasigned_url)
    : art.share?.preasigned_url
    ? [art.share]
    : [];

  function CountdownTimer({ expiresAt }) {
    const [timeLeft, setTimeLeft] = useState({ d: 0, h: 0, m: 0, s: 0 });

    useEffect(() => {
      function updateTimer() {
        const now = new Date();
        const expiry = new Date(expiresAt);
        const diff = expiry - now;

        if (diff <= 0) {
          setTimeLeft({ d: 0, h: 0, m: 0, s: 0 });
          return;
        }

        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const m = Math.floor((diff / (1000 * 60)) % 60);
        const s = Math.floor((diff / 1000) % 60);

        setTimeLeft({ d, h, m, s });
      }

      updateTimer(); // initial call
      const interval = setInterval(updateTimer, 1000);

      return () => clearInterval(interval);
    }, [expiresAt]);

    return (
      <span className="ms-2 text-success">
        ({timeLeft.d}d : {timeLeft.h}h : {timeLeft.m}m : {timeLeft.s}s)
      </span>
    );
  }
  const isLinkExpired = (expiresAt) => {
    if (!expiresAt) return true;
    return new Date(expiresAt) <= new Date();
  };

  return (
    <div className="artworkListing">
      <div className="file-info">
        <div className="file-head">
          <FontAwesomeIcon icon={icon} />
        </div>
        <div className="file-dtls">
          <p className="file-name">{fileName}</p>
          <p>
            <span>Uploaded:</span>
            {new Date(art.upload_date).toLocaleString("en-US", {
              timeZone: "UTC",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
            &nbsp; | &nbsp;
            <span>Size: {art?.size}</span>
          </p>
        </div>

        <button
          onClick={handleShare}
          className="list-share"
          disabled={art?.share && !isLinkExpired(art.share.expires_at)}
        >
          <FontAwesomeIcon icon={faLink} />
          <span>Generate Link</span>
        </button>
      </div>
      {art?.share && (
        <div className="shared-links mt-3 w-100">
          <h6>Share Links:</h6>
          <ul>
            {[]
              .concat(art.share) // normalize single object -> array
              .sort((a, b) => new Date(a.expires_at) - new Date(b.expires_at)) // sort by expiry
              .map((s, idx) => (
                <li key={idx} className="share-item">
                  <span className="btm-time">
                    Expiring on: {new Date(s.expires_at).toLocaleString()}{" "}
                    &nbsp;
                    <span className="gg-time">
                      <span className="av">|</span>Expiring in:
                      <CountdownTimer expiresAt={s.expires_at} />
                    </span>
                  </span>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() =>{
                      navigator.clipboard.writeText(s.preasigned_url);
                      copyText()
                    }
                    }
                  >
                    <FontAwesomeIcon icon={faCopy} />
                    <span>{copy ? copy : "Copy Link"}</span>
                    {/* <p className="custom-alert">{copy}</p> */}
                  </Button>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
}

function ArtWork() {
  const [activeTab, setActiveTab] = useState("view");
const fileInputRef = useRef(null);
const [showSuccess, setShowSuccess] = useState(false);
const uploadStarted = useRef(false);
  const [relative, setRelative] = useState(false);
  const [activeShare, setActiveShare] = useState(null);
  const [sortOption, setSortOption] = useState("newest");
  // inside ArtWork component

  const getFileType = (fileName = "") => {
    const ext = fileName.split(".").pop().toLowerCase();

    if (/(jpg|jpeg|png|gif|webp)$/i.test(ext)) return "image";
    if (/(mp4|mov|avi|webm)$/i.test(ext)) return "video";
    if (/(mp3|wav)$/i.test(ext)) return "audio";
    if (ext === "pdf" || ext === "ppt" || ext === "pptx") return "pdf";
    return "other";
  };

  const dispatch = useDispatch();
  const {
    shareResponse,
    loading: shareLoading,
    error: shareError,
  } = useSelector((state) => state.ArtworkShareReducer);
  // Upload reducer
  const {
    artworkData,
    error: uploadError,
    isLoading,
  } = useSelector((state) => state.ArtworkReducer);

  // View reducer
  const { items, loading, error } = useSelector(
    (state) => state.ArtworkViewReducer
  );

  console.log("loading:::", isLoading)

  // Fetch artworks on mount
  useEffect(() => {
    if (!items || items.length === 0) {
      dispatch(fetchArtworkRequest());
    }
  }, [dispatch, items]);

  // Refresh list on upload success
  useEffect(() => {
    if (artworkData) {
      // console.log("Server Response:", artworkData);
      dispatch(fetchArtworkRequest());
    }
    if (uploadError) {
      console.error("Upload Error:", uploadError);
    }
  }, [artworkData, uploadError, dispatch]);

useEffect(() => {
  if (uploadStarted.current && !isLoading && artworkData) {
    setShowSuccess(true); // show success overlay
    uploadStarted.current = false;
  }
}, [isLoading, artworkData]);


  // Trigger hidden file input
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  // Dispatch saga action on file select
const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  uploadStarted.current = true; // mark upload started
  setShowSuccess(false); // hide previous success if any
  dispatch(uploadArtworkRequest(file));
};



  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 15;

  // Calculate paginated items
  const totalPages = Math.ceil((items?.length || 0) / pageSize);
  let sortedItems = [...(items || [])];

  if (sortOption === "newest") {
    sortedItems.sort(
      (a, b) => new Date(b.upload_date) - new Date(a.upload_date)
    );
  } else if (sortOption === "oldest") {
    sortedItems.sort(
      (a, b) => new Date(a.upload_date) - new Date(b.upload_date)
    );
  } else if (sortOption !== "all") {
    sortedItems = sortedItems.filter(
      (file) => getFileType(file.file_name) === sortOption
    );
  }

  let displayItems = [];
  if (["newest", "oldest", "all"].includes(sortOption)) {
    displayItems = sortedItems.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );
  } else {
    displayItems = sortedItems; // filtered lists show all
  }

  // Function to render pagination controls
  const renderPagination = () => {
    // Show pagination only for all/newest/oldest
    if (!["newest", "oldest", "all"].includes(sortOption)) return null;
    if (totalPages <= 1) return null;

    const pages = [];
    for (let number = 1; number <= totalPages; number++) {
      pages.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => setCurrentPage(number)}
        >
          {number}
        </Pagination.Item>
      );
    }
    return <Pagination>{pages}</Pagination>;
  };

  // Build dynamic filter options
  const availableTypes = [
    ...new Set(items.map((file) => getFileType(file.file_name))),
  ];

  const filterOptions = [
    { value: "all", label: "All Files" },
    { value: "newest", label: "Sort by Date (Newest First)" },
    { value: "oldest", label: "Sort by Date (Oldest First)" },
    ...availableTypes.map((type) => {
      switch (type) {
        case "image":
          return { value: "image", label: "Only Images" };
        case "video":
          return { value: "video", label: "Only Videos" };
        case "audio":
          return { value: "audio", label: "Only Audios" };
        case "pdf":
          return { value: "pdf", label: "Only PDFs" };
        case "excel":
          return { value: "excel", label: "Only Excels" };
        default:
          return {
            value: type,
            label: `Only ${type.charAt(0).toUpperCase() + type.slice(1)}`,
          };
      }
    }),
  ];

  const location = useLocation();

  // get the access object and service name
  const access = location.state?.access;
  const service = location.state?.service;

useEffect(() => {
  if (showSuccess) {
    const timer = setTimeout(() => setShowSuccess(false), 2000); // hide after 3s
    return () => clearTimeout(timer);
  }
}, [showSuccess]);
  // console.log("test",!access?.write)
  return (
    <>
      <Header />
      <div className="art-wrok-dashboard">
        {(isLoading || shareLoading) && (
          <div className="fullpage-loader">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Processing...</span>
            </div>
          </div>
        )}

        {showSuccess && (
          <div className="fullpage-loader">
            <div className="custom-popup text-center">
              <h4 className="mb-5">File successfully uploaded</h4>
              <img src={check} alt="Success" className="mb-5" />
              <button
                onClick={() => {
                  setActiveTab("view");
                  setShowSuccess(false);
                }}
              >
                View
              </button>
            </div>
          </div>
        )}

        <Container>
          <Row>
            {/* Sidebar */}
            {/* Sidebar */}
            <Col md={3}>
              <div className="dashboard-left">
                <Row>
                  <Col md={12}>
                    <h4 className="mb-3">Select your choice</h4>
                  </Col>

                  {/* View Button */}
                  {(access === "full" || access?.r) && (
                    <Col md={12}>
                      <button
                        className="each-opt"
                        onClick={() => setActiveTab("view")}
                      >
                        View Files
                      </button>
                    </Col>
                  )}

                  {/* Upload Button */}
                  {(access === "full" || access?.w) && (
                    <Col md={12}>
                      <button
                        className="each-opt"
                        onClick={() => setActiveTab("upload")}
                      >
                        Upload Files
                      </button>
                    </Col>
                  )}
                </Row>
              </div>
            </Col>

            {/* Main Content */}
            <Col md={9}>
              <div className="dashboard-right">
                {activeTab === "view" ? (
                  <div className="view-tab1">
                    {error ? (
                      <p style={{ color: "red" }}>{error}</p>
                    ) : items?.length > 0 ? (
                      <>
                        {/* Top Controls */}
                        <div className="d-flex justify-content-end mb-3">
                          <select
                            className="form-select w-auto"
                            value={sortOption}
                            onChange={(e) => {
                              setSortOption(e.target.value);
                              setCurrentPage(1);
                            }}
                          >
                            {filterOptions.map((opt, idx) => (
                              <option key={idx} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* List or No Data */}
                        {displayItems.length === 0 ? (
                          <p className="text-muted">No data found</p>
                        ) : (
                          <ul style={{ listStyle: "none", padding: 0 }}>
                            {displayItems.map((art, idx) => (
                              <li key={idx} className="file-list">
                                <FilePreview
                                  art={art}
                                  onShare={(shareResponse) =>
                                    setActiveShare(shareResponse)
                                  }
                                />
                              </li>
                            ))}
                          </ul>
                        )}

                        {/* Pagination (only for all/newest/oldest) */}
                        {renderPagination()}

                        {/* Share Modal */}
                        <Modal
                          show={!!activeShare}
                          onHide={() => setActiveShare(null)}
                          centered
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Share Link</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            {activeShare ? (
                              <>
                                <input
                                  type="text"
                                  className="form-control mb-2"
                                  readOnly
                                  value={activeShare?.data?.url}
                                />
                                <Button
                                  variant="primary"
                                  className="me-2"
                                  onClick={() =>
                                    navigator.clipboard.writeText(
                                      activeShare?.data?.url
                                    )
                                  }
                                >
                                  Copy
                                </Button>
                              </>
                            ) : (
                              <p>No link available.</p>
                            )}
                          </Modal.Body>
                        </Modal>
                      </>
                    ) : (
                      <h2>No data found</h2>
                    )}
                  </div>
                ) : (
                  <div className="view-tab2">
                    <Row>
                      <Col md={8} className="m-auto">
                        <Row>
                          <Col md={12}>
                            <h4 className="text-center my-4">
                              Select an option
                            </h4>
                          </Col>
                          <Col md={8} className="m-auto">
                            <div className="each-opt text-center">
                              <FontAwesomeIcon icon={faUpload} />
                              <Button
                                onClick={handleUploadClick}
                                className="ms-2"
                              >
                                Upload
                              </Button>
                              {/* Hidden file input */}
                              <input
                                type="file"
                                accept="*/*"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ArtWork;
